import type { FC } from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import type { ApexOptions } from 'apexcharts';
import { connect } from 'react-redux';
import Chart from 'react-apexcharts';
import { Box } from '@material-ui/core';
import Title from 'src/components/admin/Title';
import Panel from '../../../components/global/Panel';
import PanelHeader from '../../../components/global/PanelHeader';
import PanelTitle from '../../../components/global/PanelTitle';
import PanelFilter from '../../../components/admin/PanelFilter';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import { onGet } from '../../../store/actions/global';

const Evolutivo: FC<any> = ({ onGet: onGetExec }) => {
  const isMountedRef = useIsMountedRef();
  const defaultLimit = 10;
  const [evolutivo, setEvolutivo] = useState({
    labels: [],
    values: { altas: [], cancelaciones: [] },
  });
  const [anno, setAnno] = useState('');
  const title = `Evolutivos ${anno} Convenios, En MM de PEN`;

  const chart: { series: any; options: ApexOptions } = {
    options: {
      chart: {
        stacked: false,
        toolbar: {
          show: false,
        },
      },
      colors: ['#bde5ff', '#166aaa'],
      plotOptions: {
        bar: {
          distributed: false,
          horizontal: false,
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '16px',
          colors: ['#304758', 'white'],
        },
      },
      xaxis: {
        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: true,
        },
        categories: [...evolutivo.labels],
      },
      states: {
        active: {
          filter: {
            type: 'none',
          },
        },
        hover: {
          filter: {
            type: 'none',
          },
        },
      },
      legend: {
        show: true,
        floating: false,
        position: 'top',
        fontSize: '16px',
      },
    },
    series: [
      {
        name: 'Altas',
        data: [...evolutivo.values.altas],
      },
      {
        name: 'Rechazos',
        data: [...evolutivo.values.cancelaciones],
      },
    ],
  };

  const onSubmit = async (values) => {
    if (isMountedRef.current) {
      setAnno(values?.year);
      const response = await onGetExec({
        url: '/dashboard/evolutivos',
        body: { ...values, limit: defaultLimit },
      });
      setEvolutivo(response?.evolutivo);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Dashboard:
          {title}
        </title>
      </Helmet>
      <Panel>
        <PanelHeader>
          <PanelTitle
            title={title}
            subTitlePrim="Dashboard"
            subTitleSec={title}
          />
        </PanelHeader>
        <PanelFilter onSubmit={onSubmit} year />
        <Box mt={3}>
          <Box p={2}>
            <Title title={title} />
            <Chart type="bar" height="500" {...chart} />
          </Box>
        </Box>
      </Panel>
    </>
  );
};

export default connect(null, {
  onGet,
})(Evolutivo);
